import { render, staticRenderFns } from "./FriendAdd.vue?vue&type=template&id=4030f6e9&"
import script from "./FriendAdd.vue?vue&type=script&lang=js&"
export * from "./FriendAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Ffriends%2FFriendAdd.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports